import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const InfoOutlineIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="14" stroke="currentcolor" />
    <circle cx="16" cy="11" r="1" fill="currentcolor" />
    <path stroke="currentcolor" strokeLinecap="round" d="M16 16v6" />
  </IconV2>
);

export default InfoOutlineIcon;
